import { useState } from "react";
import { Table, Space, Button,Modal,message } from "antd";
import PublisherService from "../../../services/PublisherService";
import PublisherModalForm from './PublisherModalForm'

const getColumns = (setPublisherTarget, showModalForm, showModalDelete) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: "100px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
 /*    {
      title: "Pais",
      dataIndex: "country",
      width: "150px",
      key: "country",
      render: (text, record) => <span>{record.country}</span>,
    }, */
    {
      title: "Acciones",
      key: "action",
      width: "150px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setPublisherTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setPublisherTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
}

export default function Publishers({ list = [], getData, setPublishers }) {
const [publisherTarget, setPublisherTarget] = useState(null);
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);
  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    PublisherService.deletePublisher(publisherTarget)
      .then((res) => {
        if (res.data?.success) {
          message.success("Editorial eliminada.", 3);
          getData()
            .then((res) => {
              handleCancelDelete();
              setPublishers(res);
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("No se pudo obtener la lista de Editorial.", 5);
            });
        } else {
          message.error(
            "No se pudo eliminar la Editorial. " + res.data?.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setPublisherTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setPublisherTarget(null);
        setIsModalFormVisible(false);
        setPublishers(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de Editoriales.", 5);
      });
  };

  const handleCancelForm = () => {
    setPublisherTarget(null);
    setIsModalFormVisible(false);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{marginBottom:"1em"}}
      >
        +Registrar nueva Editorial
      </Button>
      <Table
        columns={getColumns(setPublisherTarget, showModalForm, showModalDelete)}
        dataSource={list}
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      {isModalFormVisible ? (
        <PublisherModalForm
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          publisherTarget={publisherTarget}
        />
      ) : null}
      {isModalDeleteVisible?(
        <Modal
        visible={isModalDeleteVisible}
        title="Eliminar Editorial"
        onOk={handleOkDelete}
        onCancel={handleCancelDelete}
        okText="Aceptar"
        cancelText="Cancelar"
      >
        <p>
          ¿Desea eliminar la Editorial{" "}
          <strong>
            {publisherTarget?.name}
          </strong>
          ?
        </p>
      </Modal>
      ):null}
    </>
  );
}
